module.exports = __webpack_public_path__ + "static/media/facebook_rc.0a94bf49.svg";